<template>
  <div class="card listing-card">
    <form @submit.prevent class="needs-validation" novalidate>
      <div v-if="serverError" class="alert alert-danger" role="alert">
        {{serverError}}
      </div>
      <div class="card-body">
        <div class="label-text">
          <span v-if="isAdd">Add Conservation Purpose</span>
          <span v-if="!isAdd">Edit Conservation Purpose</span>
        </div>
        <hr>
        <div class="form-group row">
          <label for="purpose" class="col-lg-4 label-text">
            <span v-if="isAdd" class="text-danger">*</span>Purpose Name
          </label>
          <div class="loading col-lg-5" v-if="purposeOptionsLoading">
            Loading...
          </div>
          <div class="col-lg-8">
            <select v-if="!purposeOptionsLoading && isAdd"
                    v-validate="'required'"
                    data-vv-as="Purpose"
                    class="form-control"
                    name="purpose"
                    v-model="conservationPurpose.purposeId">
              <option value="" disabled>Select Purpose Name</option>
              <option v-for="option in unselectedPurposes"
                      :key="option.id"
                      :value="option.id">
                {{ option.name }}
              </option>
            </select>
            <div v-if="isAdd" class="invalid-feedback">{{ errors.first('purpose') }}</div>
            <div v-if="!isAdd">
              {{ getPurposeName(conservationPurpose.purposeId) }}
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="comments" class="col-lg-4 col-form-label label-text">
            <span class="text-danger">*</span>Comments
          </label>
          <div class="col-lg-8">
            <textarea data-vv-as="Comments"
                      type="textarea"
                      class="form-control"
                      name="comments"
                      v-validate="'required|min:2'"
                      v-model="conservationPurpose.comments"
                      placeholder="Enter Comments"
                      rows="2"
                      maxlength="2000" />
              <small v-if="!errors.first('comments')" class="form-text text-muted">
                Minimum 2 characters. Max 2000 characters
              </small>
              <div class="invalid-feedback">{{ errors.first('comments') }}</div>
          </div>
        </div>
      </div>
      <div class='card-footer right-align-content'>
        <b-button :disabled="submitting" variant="danger" class="button-row-spacing"
                  v-b-modal="'cancelConservationPurposeConfirmation-' + conservationPurpose.id">
          Cancel
        </b-button>
        <b-button
          :disabled="submitting"
          @click="submitWrapper(conservationPurpose)"
          >
          Save
        </b-button>
      </div>
    </form>
    <CancelModal
      :modalId="'cancelConservationPurposeConfirmation-' + conservationPurpose.id"
      @cancelled="cancelEdit">
    </CancelModal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CancelModal from '../CancelModal.vue';
import FormSubmit from '../../mixins/FormSubmit';
import { EntityModules, LookupModules } from '@/store/moduleConfig';

export default {
  name: 'ConservationPurposesForm',
  components: {
    CancelModal,
  },
  mixins: [FormSubmit],
  props: [
    'conservationPurpose',
  ],
  computed: {
    ...mapState(LookupModules.PURPOSES.namespace, {
      purposeOptionsLoading: state => state.loading,
    }),
    ...mapState(EntityModules.CONSERVATION_PURPOSE.namespace, {
      entities: state => state.entities,
      serverError: state => state.serverError,
      submitting: state => state.submitting,
    }),
    ...mapGetters(LookupModules.PURPOSES.namespace, {
      getPurposeName: 'getName',
      purposeOptions: 'getActiveOptions',
    }),
    isAdd() {
      return !this.conservationPurpose.id;
    },
    unselectedPurposes() {
      return this.purposeOptions.filter(option => this.entities && !this.entities
        .some(cp => cp.purposeId === option.id));
    },
  },
  methods: {
    cancelEdit() {
      this.$emit('closeForm', this.conservationPurpose.id);
    },
    submitWrapper(entity) {
      this.onSubmit(
        entity,
        EntityModules.CONSERVATION_PURPOSE.namespace,
        null,
        this.$emit('closeForm', entity.id),
      );
    },
  },
};
</script>
